import { COLOR_VALUES } from "shared/config/colors";
import styled from "styled-components";

export const DividerWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;

    &:hover {
        background-color: ${COLOR_VALUES.Gray_6};
    }
`;

export const DividerLine = styled.div`
    flex: 1;
    height: 1px;
    background-color: ${COLOR_VALUES.Gray_3};
`;

export const DividerText = styled.span`
    padding: 0 8px;
    font-size: 12px;
    color: ${COLOR_VALUES.Gray_1};
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
`;
